import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { NgbModalOptions, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PerkModalComponent } from 'src/app/modals/perk/perk-modal.component';
import { Router } from '@angular/router';
import { WidgetSize } from 'src/app/interfaces/perk';
import { UserService } from '../../../services/user/user.service'
import { ClickEventNumbersEnum } from 'src/app/interfaces/clickEventNumbers';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-perk-widget',
  templateUrl: './perk-widget.component.html',
  styleUrls: ['./perk-widget.component.scss']
})
export class PerkWidgetComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() enabled = true;
  @Input() perk: any;
  @Input() preview = false;
  @Input() widgetSize = WidgetSize.Medium;
  @Input() disabledText = 'Coming soon';
  @Input() totalNumberOfPerks: number;
  @Input() currentPerkNumber: number;

  @Output() lastPerkRendered: EventEmitter<void> = new EventEmitter();

  perkModalRef?: NgbModalRef;
  perkEventData?: any;
  perkID: string;
  isBrowser: boolean;

  ClickEventNumbersEnum = ClickEventNumbersEnum;

  public WidgetSizeEnum = WidgetSize;

  constructor(
    private modalService: NgbModal,
    public router: Router,
    private userService: UserService,
    @Inject(PLATFORM_ID) private platformId: Object,
    ) {
      this.isBrowser = isPlatformBrowser(this.platformId);
    }

  selectPerk() {
    if (this.enabled && !this.preview) {
      if (this.perk.modal) {
        const modalOptions: NgbModalOptions = {
          centered: true,
          size: 'xl',
        };

        if (!this.perk.widget.redirectUri || !this.perk.widget.redirectUri.startsWith('http')) {
          this.perkModalRef = this.modalService.open(PerkModalComponent, modalOptions);
          this.perkModalRef.componentInstance.perk = this.perk;
          this.perkModalRef
            .result
              .then(() => {
                this.trackEvent(`perksmodal::${this.perk.name}::gotopartnersite::clicked`, this.perkEventData);
              })
              .catch((reason) => {
                if (reason !== 'destroyed') {
                  this.trackEvent(`perksmodal::${this.perk.name}::exitclicked`, this.perkEventData);
                }
              });

          this.trackEvent(`dashboard::widget::${this.perk.name}::opened`, this.perkEventData);
        }
      }

      if (this.perk.widget.redirectUri) {
        if (this.perk.shortCode) {
          this.userService.sendVoucherEmail(this.perk.shortCode);
        }
        if (this.isBrowser && this.perk.widget.redirectUri.startsWith('http')){
          window.open(this.perk.widget.redirectUri, '_blank');
        } else {
          this.router.navigate([`/${this.perk.widget.redirectUri}`]);
        }
      }
    }

    if (this.preview) {
      this.router.navigate(['/account/account-type']);
    }
  }

  trackEvent(event: string, data?: any) {
    if (!this.isBrowser) return;
    window.analytics.track(event, data);
  }

  ngOnInit(): void {
    this.perkID = this.perk.name
    if (this.perk.tag) {
      this.perkID = this.perk.tag
      this.perkEventData = {
        tag: this.perk.tag,
      };
    }
    this.trackEvent(`dashboard::widget::${this.perk.name}::visible`, this.perkEventData);
  }

  ngAfterViewInit(): void {
    if (this.currentPerkNumber == this.totalNumberOfPerks) {
      this.lastPerkRendered.emit();
    }
  }

  ngOnDestroy(): void {
    this.perkModalRef?.dismiss('destroyed');
  }
}
